import React from "react";
import facebookIcon from "../../assets/images/footer/facebook-icon.png";
import twitterIcon from "../../assets/images/footer/x-twitter.svg";
import youtubeIcon from "../../assets/images/footer/youtube-icon.png";
import linkedInIcon from "../../assets/images/footer/linkedin-icon.png";
import instagramIcon from "../../assets/images/footer/instagram-icon.png";
import { ReactComponent as ContendZONE } from "../../assets/images/contendZONEone.svg";
import { Link } from "react-router-dom";
import userService from "../../services/user.service";

class ContactUs extends React.Component {
  state = {
    socialLink: [],
    appLinks: [
      {
        label: "Plans Pricing",
        link: "/pricing",
      },
      {
        label: "Highlights",
        link: "/highlights",
      },
      {
        label: "Guidelines",
        link: "/guidelines",
      },
      {
        label: "Contact Us",
        link: "/contactus",
      },
    ],
  };

  componentDidMount() {
    this.getFooterData();
  }

  getFooterData() {
    userService.getFooterData().then((res) => {
      const {
        data: {
          data: { footerDetailsResponses },
        },
      } = res;
      var details = res.data.data.footerDetailsResponses[0].details;
      var facebookLink = res.data.data.footerDetailsResponses[0].facebookLink;
      var instagramLink = res.data.data.footerDetailsResponses[0].instagramLink;
      var linkedinLink = res.data.data.footerDetailsResponses[0].linkedinLink;
      var twitterLink = res.data.data.footerDetailsResponses[0].twitterLink;
      var youtubeLink = res.data.data.footerDetailsResponses[0].youtubeLink;
      var footId = res.data.data.footerDetailsResponses[0].id;
      this.setState({
        details,
        facebookLink,
        instagramLink,
        linkedinLink,
        twitterLink,
        youtubeLink,
        footId,
        socialLink: [
          {
            src: facebookIcon,
            link: footerDetailsResponses[0]?.facebookLink,
          },
          {
            src: twitterIcon,
            link: footerDetailsResponses[0]?.twitterLink,
          },
          {
            src: youtubeIcon,
            link: footerDetailsResponses[0]?.youtubeLink,
          },
          {
            src: linkedInIcon,
            link: footerDetailsResponses[0]?.linkedinLink,
          },
          {
            src: instagramIcon,
            link: footerDetailsResponses[0]?.instagramLink,
          },
        ],
      });
    });
  }

  renderSocialLinks = () => {
    const { socialLink } = this.state;
    return (
      <>
        <span className="footer-social">WE ARE SOCIAL</span>
        <div className="footer-social-container">
          {socialLink?.map((item, index) => (
            <a href={item.link} key={index} target="_blank" rel="noreferrer">
              <img alt="" src={item.src} />
            </a>
          ))}
        </div>
      </>
    );
  };

  render() {
    const { details, appLinks } = this.state;
    return (
      <section className="footer-section">
        <div className="footer-container-left">
          <Link to="/">
            <ContendZONE className="footer-logo" />
          </Link>
          <p>{details}</p>
          <div className="footer-social-web">{this.renderSocialLinks()}</div>
        </div>
        <div className="footer-container-right">
          {appLinks.map((item, index) => (
            <Link key={index} to={item.link}>
              {item.label}
            </Link>
          ))}
        </div>
        <div className="footer-social-mob">{this.renderSocialLinks()}</div>
      </section>
    );
  }
}

export default ContactUs;
